export enum ErrorCode {
  // Authentication Errors (1xxx)
  INVALID_CREDENTIALS = 1001,
  EMAIL_ALREADY_EXISTS = 1002,
  USER_NOT_FOUND = 1003,
  SESSION_EXPIRED = 1004,
  NOT_AUTHENTICATED = 1005,
  PASSWORD_INVALID = 1006,
  GOOGLE_AUTH_FAILED = 1007,
  
  // OTP Errors (2xxx)
  OTP_EXPIRED = 2001,
  OTP_INVALID = 2002,
  OTP_LOCKED = 2003,
  OTP_SEND_FAILED = 2004,
  OTP_TOO_MANY_REQUESTS = 2005,
  
  // Database Errors (3xxx)
  DB_CONNECTION_FAILED = 3001,
  DB_CONSTRAINT_VIOLATION = 3002,
  DB_RLS_VIOLATION = 3003,
  DB_QUERY_FAILED = 3004,
  DB_NOT_FOUND = 3005,
  DB_TIMEOUT = 3006,
  
  // Email Service Errors (4xxx)
  EMAIL_SEND_FAILED = 4001,
  EMAIL_INVALID = 4002,
  
  // Rate Limiting (5xxx)
  RATE_LIMIT_EXCEEDED = 5001,
  
  // Validation Errors (6xxx)
  VALIDATION_FAILED = 6001,
  PASSWORD_WEAK = 6002,
  FIELD_REQUIRED = 6003,
  FIELD_INVALID = 6004,
  FIELD_TOO_LONG = 6005,
  FIELD_TOO_SHORT = 6006,
  
  // File Upload Errors (7xxx)
  FILE_TOO_LARGE = 7001,
  FILE_INVALID_TYPE = 7002,
  FILE_UPLOAD_FAILED = 7003,
  FILE_PARSE_ERROR = 7004,
  FILE_EMPTY = 7005,
  
  // Business Logic Errors (8xxx)
  INSUFFICIENT_STOCK = 8001,
  INVOICE_ALREADY_PAID = 8002,
  LEDGER_CORRUPTED = 8003,
  ORGANIZATION_NOT_FOUND = 8004,
  CANNOT_DELETE = 8005,
  CANNOT_EDIT = 8006,
  
  // Network Errors (9xxx)
  NETWORK_OFFLINE = 9001,
  NETWORK_TIMEOUT = 9002,
  SERVER_ERROR = 9003,
  
  // Generic/Unknown
  UNKNOWN_ERROR = 9999
}

export interface StructuredError {
  code: ErrorCode;
  message: string; // User-friendly message
  details?: string; // Technical details for logging
  field?: string; // Which field caused the error
  retryable: boolean; // Can user retry?
  action?: string; // Suggested action
}

export class AppError extends Error {
  constructor(
    public code: ErrorCode,
    message: string,
    public details?: string,
    public field?: string,
    public retryable: boolean = true,
    public action?: string
  ) {
    super(message);
    this.name = 'AppError';
  }

  toJSON(): StructuredError {
    return {
      code: this.code,
      message: this.message,
      details: this.details,
      field: this.field,
      retryable: this.retryable,
      action: this.action
    };
  }
}
